import {
  AppPublicLayout,
  AppPublicPage,
  PublicDocument,
} from "./../layout";

export function Impressum() {
  return (
    <AppPublicLayout>
      <AppPublicPage width="narrow">
        <PublicDocument>
          <h1>Impressum</h1>

          <p className="lead">
            Angaben gemäß § 5 DDG sowie weitere rechtliche Pflichtinformationen.
          </p>

          <h2>Anbieter</h2>
          <address>
            Lukas Ottweiler
            <br />
            Logami
            <br />
            c/o MDC#986
            <br />
            Welserstraße 3
            <br />
            87463 Dietmannsried
            <br />
            Deutschland
          </address>

          <h2>Kontakt</h2>
          <p>
            E-Mail:{" "}
            <a href="mailto:kontakt@logami.de">kontakt@logami.de</a>
          </p>

          <h2>Umsatzsteuer-ID</h2>
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
            <br />
            DE462255205
          </p>

          <h2>Redaktionell verantwortlich</h2>
          <address>
            Lukas Ottweiler
            <br />
            c/o MDC#986
            <br />
            Welserstraße 3
            <br />
            87463 Dietmannsried
            <br />
            Deutschland
          </address>

          <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
            vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>

          <h2>Zentrale Kontaktstelle nach dem Digital Services Act - DSA</h2>
          <p>
            Unsere zentrale Kontaktstelle für Nutzer und Behörden nach Art. 11,
            12 DSA erreichen Sie wie folgt:
          </p>

          <p>
            E-Mail:{" "}
            <a href="mailto:kontakt@logami.de">kontakt@logami.de</a>
          </p>

          <p>
            Die für den Kontakt zur Verfügung stehenden Sprachen sind: Deutsch,
            Englisch.
          </p>

          <h2>Quelle</h2>
          <p>
            Erstellt mit dem Impressum-Generator von{" "}
            <a
              href="https://www.e-recht24.de"
              target="_blank"
              rel="noopener noreferrer"
            >
              eRecht24
            </a>
            .
          </p>
        </PublicDocument>
      </AppPublicPage>
    </AppPublicLayout>
  );
}

export default Impressum;
